import {
  Icon,
  Type as BaseType,
  Value,
} from 'components/base/Form/Input/types'

export enum Type {
  address = 'address',
  color = 'color',
  date = 'date',
  datetime = 'datetime',
  email = 'email',
  month = 'month',
  number = 'number',
  password = 'password',
  range = 'range',
  search = 'search',
  tel = 'tel',
  text = 'text',
  time = 'time',
  url = 'url',
  week = 'week',
}

export interface ContaninerProps {
  createdByCorrectParent?: boolean,
  defaultValue?: Value,
  icon?: Icon,
  onChange?(event: React.ChangeEvent | PlacesAutocompleteChangeEvent): void,
  placeholder?: string,
  type?: BaseType,
  valid?: boolean,
  value?: Value,
}

export type PlacesAutocompleteChangeEvent = { target: { value: string }}

export interface Props extends ContaninerProps {
  alwaysShowError?: boolean,
  componentType?: 'address' | 'date' | 'datetime' | 'input' | 'time' | any, // eslint-disable-line @typescript-eslint/no-explicit-any
  error?: string,
  loading?: boolean,
  name?: string,
  pristine?: boolean,
  ref?: React.RefObject<HTMLInputElement>,
  touched?: boolean,
  uppercase?: boolean,
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void,
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void,
}

export interface ErrorLogicProps {
  valid: boolean,
  touched: boolean,
  pristine: boolean,
  alwaysShowError: boolean,
}
